export default __webpack_public_path__ + "static/media/openRequest_active.40e3477b.svg";